import React from 'react';
import ReactLoading from "react-loading";

function Loading({ size }) {
  return (
    <div className='loading'> <ReactLoading type="spinningBubbles" color="#56148a"
                    height={size} width={size} /></div>
  );
}

export default Loading;


